import React from 'react';
import PropTypes from 'prop-types';
import './AdminShell.css';

/**
 * Admin sidebar + main content shell (security, user detail, records).
 */
export function AdminShell({ sidebar, children, className = '', mainRef = null }) {
  return (
    <div
      className={['onyx-admin-shell', className].filter(Boolean).join(' ')}
      data-testid="onyx-admin-shell"
    >
      {sidebar}
      <div className="onyx-admin-shell__main" ref={mainRef} data-testid="onyx-admin-shell-main">
        {children}
      </div>
    </div>
  );
}

AdminShell.propTypes = {
  sidebar: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
  mainRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
};

/**
 * Sidebar chrome for admin shells.
 * items = nav list; children = freeform body (filter stacks, forms).
 */
export function AdminSidebar({
  title,
  items = [],
  activeId,
  onSelect,
  footer,
  header,
  children = null,
  className = '',
}) {
  return (
    <aside
      className={['onyx-admin-sidebar', className].filter(Boolean).join(' ')}
      data-testid="onyx-admin-sidebar"
    >
      {title ? (
        <div className="onyx-admin-sidebar__title">{title}</div>
      ) : null}
      {header ? (
        <div className="onyx-admin-sidebar__header">{header}</div>
      ) : null}
      {children ? (
        <div className="onyx-admin-sidebar__body" data-testid="onyx-admin-sidebar-body">
          {children}
        </div>
      ) : null}
      {items.length > 0 ? (
        <nav className="onyx-admin-sidebar__nav" aria-label={title || 'Admin sections'}>
          {items.map((item) => (
            <button
              key={item.id}
              type="button"
              className={[
                'onyx-admin-sidebar__item',
                activeId === item.id ? 'onyx-admin-sidebar__item--active' : '',
                item.danger ? 'onyx-admin-sidebar__item--danger' : '',
              ]
                .filter(Boolean)
                .join(' ')}
              onClick={() => onSelect?.(item.id)}
            >
              {item.label}
              {item.meta != null && item.meta !== '' ? (
                <span className="onyx-admin-sidebar__meta">{item.meta}</span>
              ) : null}
            </button>
          ))}
        </nav>
      ) : null}
      {footer ? <div className="onyx-admin-sidebar__footer">{footer}</div> : null}
    </aside>
  );
}

AdminSidebar.propTypes = {
  title: PropTypes.node,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.node.isRequired,
      danger: PropTypes.bool,
      meta: PropTypes.node,
    }),
  ),
  activeId: PropTypes.string,
  onSelect: PropTypes.func,
  footer: PropTypes.node,
  header: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default AdminShell;
